export default __webpack_public_path__ + "static/media/comfirmationCircle2Dark.b27327c5.svg";